<template>
  <BaseLoading v-if="isLoading" :class="$style.container" />
  <div v-else :class="$style.container">
    <p class="margin-bottom24 text-input site-settings-info-copy">
      GRiP domain/category(ies) created will be applied to all data collection
      period(s) and data collection site(s) in this project.
    </p>
    <div v-if="items.length > 0">
      <DomainCategoryList :gripDomainCategories="items" />
      <div :class="$style.addItem">
        <a @click="openDomainCategoryModal">+ Add Domain/Category</a>
      </div>
    </div>
    <div v-else>
      <div :class="$style.nullContainer">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p :class="$style.noDataTextBold">No data found</p>
            <p :class="$style.noDataText">
              Click the add Domain/Category button below to create new
              Domain/Categories.
            </p>
            <br />
            <a
              @click="openDomainCategoryModal"
              :class="[$style.addDomainCategoryButton, 'button', 'is-primary']"
              >+ Add Domain/Category</a
            >
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import DomainCategoryList from './DomainCategoryList.vue';
import { GripDomainCategory } from '../../../store/types/grip.types';
import DomainCategoryModal from './DomainCategoryModal.vue';
import { ApiState } from '../../../store/types/general.types';
import BaseLoading from '../../../components/base/BaseLoading.vue';

@Component({
  components: { BaseLoading, DomainCategoryList, DomainCategoryModal },
})
export default class DomainCategorySettings extends Vue {
  public isLoading: boolean = false;

  @Action('projects/getGripDomainCategories')
  public getGripDomainCategories!: (projectId: number) => void;

  @State((state) => state.projects.apiState.getGripDomainCategories)
  public getGripDomainCategoriesState!: ApiState;

  @State((state) => state.projects.gripDomainCategories)
  public gripDomainCategories!: GripDomainCategory[];

  get DomainCategoryList() {
    return DomainCategoryList;
  }

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  get items(): GripDomainCategory[] {
    return this.gripDomainCategories ? this.gripDomainCategories : [];
  }

  public openDomainCategoryModal(): void {
    this.$buefy.modal.open({
      parent: this,
      props: {
        projectId: this.projectId,
        modalTitle: 'Add',
      },
      component: DomainCategoryModal,
      hasModalCard: true,
    });
  }

  public mounted(): void {
    this.getGripDomainCategories(this.projectId);
  }

  @Watch('getGripDomainCategoriesState')
  public watchGetGripDomainCategoryLoading(state: ApiState): void {
    if (state.loading) {
      this.isLoading = true;
    } else {
      this.isLoading = false;
    }
  }
}
</script>
<style lang="scss" module>
.container {
  width: 680px;
  margin-right: auto;
  margin-left: 20px;
}
.addItem {
  color: #00205b;
  font-weight: 700;
  margin-top: -11px;
  font-size: 14px;
  line-height: 17px;
  padding-top: 10px;
}
.nullContainer {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 1rem;
  box-shadow: 0 2px 2px $grey-border;
  border: 0.5px solid $grey-border;
  border-radius: 6px;
  background: #ffffff;
  overflow-x: auto;
}
.noDataTextBold {
  font-size: 18px;
  font-weight: bold;
  color: #9f9f9f;
}
.noDataText {
  font-size: 16px;
  color: #9f9f9f;
}
.addDomainCategoryButton {
  color: #ffffff;
  background-color: #00205b;
  border-color: transparent;
  border-radius: 24px;
  padding: 12px 16px;
}
</style>
